<template>
  <div>
    <router-view v-if="render"/>
    <ConnectionStatus />
  </div>
</template>

<script>
import { socket, connect } from "@/socket";
import { toast } from "vue3-toastify";
import pingSound from "@/assets/audio/ping_sound.mp3";
import { h } from "vue";
import axios from "axios";
import ConnectionStatus from "./views/ConnectionStatus.vue";

export default {
  data() {
    return {
      userId: null,
      audio: null,
      audioUnlocked: false,
      render: true,
    };
  },
  components: {
    ConnectionStatus
  },
  mounted() {
    //  this.$router.isReady().then(() => {
    //   this.getUser();
    // });
    // Create reusable audio instance
    this.audio = new Audio(pingSound);

    // Unlock audio after first user interaction (browser policy)
    window.addEventListener(
      "click",
      () => {
        this.audioUnlocked = true;
      },
      { once: true }
    );

    // Get user from store
    const storedUserId = this.$store?.state?.user?.id;

    if (storedUserId) {
      this.userId = storedUserId;

      // Connect socket
      connect(this.userId);

      // Prevent duplicate listeners
      socket.off("ping");
      socket.off("connect");
      socket.off("disconnect");

      // Global listener for pings
      socket.on("ping", (data) => {
        const notificationType = String(
          data?.notificationType || ""
        ).trim().toLowerCase();

        const isSilentCommentUpdate = [
          "comment_edit",
          "comment_delete",
        ].includes(notificationType);

        if (!isSilentCommentUpdate) {
          toast.success(
          () =>
            h(
              "div",
              {
                class: "flex w-full items-start gap-3 p-1",
              },
              [
                // icon indicator
                h("div", {
                  class:
                    "mt-2 h-2 w-2 flex-shrink-0 rounded-full bg-green-500",
                }),

                // content
                h(
                  "div",
                  {
                    class: "flex min-w-0 flex-1 flex-col gap-2",
                  },
                  [
                    // title/message
                    h(
                      "div",
                      {
                        class:
                          "break-words text-xs font-medium leading-snug text-gray-800",
                      },
                      data.message
                    ),

                    // action button row
                    h(
                      "div",
                      {
                        class: "flex items-center justify-start",
                      },
                      [
                        h(
                          "button",
                          {
                            class:
                              "inline-flex items-center gap-1 rounded-md bg-green-600 px-3 py-1.5 text-xs font-medium text-white shadow-sm transition-all duration-150 hover:bg-green-700 active:scale-[0.98]",
                            onClick: (e) => {
                              e.stopPropagation();

                              if (!data.route) return;

                              // Route was sent as a plain URL string
                              if (typeof data.route === "string") {
                                const route = data.route.startsWith("/")
                                  ? data.route
                                  : `/${data.route}`;

                                this.$router.push(route).catch(() => {});
                                return;
                              }

                              // Named Vue Router route
                              if (data.route.name) {
                                this.$router
                                  .push({
                                    name: data.route.name,
                                    query: data.route.query || {},
                                    params: data.route.params || {},
                                  })
                                  .catch(() => {});

                                return;
                              }

                              // Route object using path
                              if (data.route.path) {
                                this.$router
                                  .push({
                                    path: data.route.path,
                                    query: data.route.query || {},
                                  })
                                  .catch(() => {});
                              }
                            },
                          },
                          "View details"
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          {
            autoClose: 15000,
            closeOnClick: false,
            closeButton: true,
            hideProgressBar: false,
            position: "top-right",
            pauseOnHover: true,
            draggable: false,

            // Increased toast width while remaining responsive
            style: {
              width: "440px",
              maxWidth: "calc(100vw - 2rem)",
            },

            className:
              "shadow-lg border border-gray-100 rounded-lg bg-white",
          }
        );
        }

        /*
         * Notify mounted notification components that a new persistent
         * notification has been received. The navbar and NotificationsView
         * will refresh their count and notification list from the backend.
         */
        window.dispatchEvent(
          new CustomEvent("notifications-updated", {
            detail: {
              source: "socket-ping",
              notificationId:
                data?.notificationId || null,
              notificationType:
                data?.notificationType || null,
              route:
                data?.route || null,
            },
          })
        );

        if (!isSilentCommentUpdate) {
          this.playPingSound();
        }
      });

      // Handle reconnect automatically
      socket.on("connect", () => {
        console.log("Socket connected:", socket.id);

        if (this.userId) {
          socket.emit("join", this.userId);
          console.log("Re-joined room for user:", this.userId);
        }
      });

      // Optional: handle disconnect
      socket.on("disconnect", (reason) => {
        console.warn("Socket disconnected:", reason);
      });
    }
  },
  // created() {
  // const urlParams = new URLSearchParams(window.location.search);

  //   const urlToken = urlParams.get("token");
  //   const urlUserId = urlParams.get("user_id");

  //   const localToken = localStorage.getItem("token");

  //   if (urlToken) {
  //     if (!localToken || urlToken === localToken) {
  //       localStorage.setItem("token", urlToken);

  //       if (urlUserId) {
  //         localStorage.setItem("user_id", urlUserId);
  //       }

  //       // remove query from URL
  //       window.history.replaceState(
  //         {},
  //         document.title,
  //         window.location.pathname
  //       );
  //     } else {
  //       localStorage.clear();
  //       this.$router.replace("/");
  //       return;
  //     }
  //   }
  // },
  methods: {
     getUser() {
  const localToken = localStorage.getItem("token");

  if (!localToken) {
    this.render = true;
    localStorage.clear();
    this.$router.replace("/");
    return;
  }

  this.render = false;
  console.log("TOKEN SENT TO AUTH ME:", localToken);

  axios
    .get(process.env.VUE_APP_BASE_URL + "/auth/me", {
      headers: {
        Authorization: `Bearer ${localToken}`,
      },
    })
    .then((res) => {
      const user = res.data.data;

      this.$store.dispatch("setUser", user);
      localStorage.setItem("user_id", user.id);
      this.$store.commit('UPDATE_USER',user);

      const publicPages = ["/", "/login"];

      if (publicPages.includes(this.$route.path)) {
        this.$router.replace("/dashboard");
      }
    })
    .catch((err) => {
      console.log(err);
      localStorage.clear();
      this.$router.replace("/");
    })
    .finally(() => {
      this.render = true;
    });
},
    playPingSound() {
      if (!this.audioUnlocked || !this.audio) return;

      try {
        this.audio.currentTime = 0;
        this.audio.play().catch(() => {});
      } catch (error) {
        console.warn("Audio play failed:", error);
      }
    },
  },
};
</script>

<style></style>
